import React from 'react';
import PropTypes from 'prop-types';
import {TimePicker} from '@mui/x-date-pickers';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';

const TimePickerFull = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        {...props}
        slotProps={{
          textField: {
            ...props.textFieldProps,
          },
        }}
      />
    </LocalizationProvider>
  );
};

TimePickerFull.propTypes = {
  locale: PropTypes.string,
  textFieldProps: PropTypes.object,
};

export default React.memo(TimePickerFull);
